<template>
  <Layout>
    <template #content>
      <div class="signinSheet" >
        <!-- <div class="banner"> 先不用banner
          <img :src="require(`@/website/${DEF_webStyle}/images/signinSheet/banner.webp`)" class="img-fluid" />
        </div> -->
        <Info />
        <Sheet :sheet-id="1"/>
        <Notice />
      </div>
    </template>
  </Layout>
</template>
<script>
const Layout = require(`~/components/desktop/layouts/${process.env.DEF_webFrame}.vue`).default;
import Info from '~/pages/event/signinSheet/info.vue';
import Sheet from '~/pages/event/signinSheet/sheet.vue';
import Notice from '~/pages/event/signinSheet/notice.vue';

export default {
  components: {
    Layout,
    Info,
    Sheet,
    Notice
  },
  computed: {
    DEF_webStyle() {
      return process.env.DEF_webStyle || 'default';
    },
  }
};
</script>

